import React from "react";
import { Form } from "antd";

function FormComponent({
  formProps,
  formLayout,
  children,
  form,
  initialValues,
}) {
  // const [form] = Form.useForm();

  return (
    <Form
      autoComplete="off"
      {...formProps}
      layout={formLayout}
      form={form}
      scrollToFirstError={{
        behavior: "smooth",
        block: "center",
        inline: "center",
      }}
      className="global-form"
      initialValues={initialValues}
      //   onValuesChange={(e) => onFormLayoutChange(e)}
    >
      {children}
    </Form>
  );
}

export default FormComponent;
